// src/i18n/weatherVoice/is.js
//
// Weather Voice primary Icelandic personality library for the five sarcastic
// conditions. Each entry is only `{ id, text }`; condition, mood, voice level,
// cooldown and CTA live once in weatherVoiceContent.js's shared registry.
// Cautious and serious text is never listed here (see safety.js). Retired and
// excluded IDs are never listed here (see RETIRED_JOKE_IDS and the ledger).
export const is = [
  { id: "good_01", text: "Þetta má alveg." },
  { id: "good_02", text: "Jæja. Þetta er bara gott." },
  { id: "good_03", text: "Engin kvörtun að sinni." },
  { id: "good_04", text: "Ég finn ekkert að þessu." },
  { id: "good_05", text: "Veðrið hagar sér." },
  { id: "good_06", text: "Það hefur verið verra." },
  { id: "good_07", text: "Ég samþykki þetta." },
  { id: "good_08", text: "Engin ástæða til dramatíkur." },
  { id: "good_09", text: "Þetta er furðulega eðlilegt." },
  { id: "good_10", text: "Ég ætla ekki að eyðileggja þetta með kvörtunum." },
  { id: "good_11", text: "Þetta stenst skoðun." },
  { id: "good_12", text: "Jæja. Engin gild afsökun." },
  { id: "good_13", text: "Ég hafði áhyggjur að óþörfu." },
  { id: "good_14", text: "Veðrið kom undirbúið." },
  { id: "good_15", text: "Ég get unnið með þetta." },
  { id: "good_16", text: "Þetta verður ekki mikið betra án þess að verða grunsamlegt." },
  { id: "good_17", text: "Ég ætla bara að njóta þessa í hljóði." },
  { id: "good_18", text: "Ekkert vesen. Skrítið." },
  { id: "good_19", text: "Þetta er næstum því fullorðinslegt veður." },
  { id: "good_20", text: "Íslenska veðrið gleymdi sér." },
  { id: "good_21", text: "Allt í lagi. Þú vinnur." },
  { id: "good_22", text: "Ég var tilbúinn að kvarta." },
  { id: "good_23", text: "Þetta er eiginlega bara fínt." },
  { id: "excellent_01", text: "Þetta er grunsamlega gott." },
  { id: "excellent_03", text: "Nú vantar bara kaffið." },
  { id: "excellent_04", text: "Þetta er útiveður." },
  { id: "excellent_05", text: "Jæja. Þetta er óþægilega gott." },
  { id: "excellent_06", text: "Ég var ekki undirbúinn fyrir þetta." },
  { id: "excellent_07", text: "Eitthvað hlýtur að vera að." },
  { id: "excellent_08", text: "Þetta þarf eiginlega ljósmyndasönnun." },
  { id: "excellent_09", text: "Ég hef... ekkert að kvarta yfir." },
  { id: "excellent_10", text: "Þetta gerist víst." },
  { id: "excellent_11", text: "Ég ætla að láta þetta eiga sig." },
  { id: "excellent_12", text: "Nei sko." },
  { id: "excellent_13", text: "Þetta er eiginlega óþarfi." },
  { id: "excellent_14", text: "Veðrið er að sýna sig." },
  { id: "excellent_15", text: "Ég kann ekki alveg við þetta." },
  { id: "excellent_16", text: "Hver pantaði þetta?" },
  { id: "excellent_17", text: "Þetta er ekki mjög íslenskt." },
  { id: "excellent_18", text: "Ég athugaði tvisvar." },
  { id: "excellent_19", text: "Þetta er gott. Grunsamlega gott." },
  { id: "excellent_20", text: "Ég er orðlaus. Næstum því." },
  { id: "excellent_21", text: "Allt í lagi. Þetta er frábært." },
  { id: "excellent_22", text: "Ég ætla ekki að spyrja spurninga." },
  { id: "excellent_23", text: "Svona á víst að gera þetta." },
  { id: "rain_01", text: "Það fylgir vatn með." },
  { id: "rain_02", text: "Regnjakki með aðalhlutverk." },
  { id: "rain_03", text: "Vatn. Að ofan." },
  { id: "rain_04", text: "Já já. Rigning." },
  { id: "rain_05", text: "Auðvitað." },
  { id: "rain_06", text: "Þurrt fær frí í dag." },
  { id: "rain_07", text: "Himinninn lekur." },
  { id: "rain_08", text: "Þetta þurfti greinilega að vera blautt." },
  { id: "rain_09", text: "Veðrið valdi vatn." },
  { id: "rain_10", text: "Rigningin mætti á réttum tíma. Eins og alltaf." },
  { id: "rain_11", text: "Þurrkur var greinilega ekki á dagskrá." },
  { id: "rain_12", text: "Vatnsheldur er fallegt orð." },
  { id: "rain_13", text: "Þetta er mjög íslenskt." },
  { id: "rain_14", text: "Regnið er komið. Það fannst öllum vanta." },
  { id: "rain_15", text: "Nú er allt aðeins blautara." },
  { id: "rain_16", text: "Himinninn er í þvottaham." },
  { id: "rain_17", text: "Rigningin hefur tekið vaktina." },
  { id: "rain_18", text: "Það þurfti víst að vökva." },
  { id: "rain_19", text: "Veðrið fór blautu leiðina." },
  { id: "rain_20", text: "Þurrt hefði verið of einfalt." },
  { id: "rain_21", text: "Rigning. Klassískt." },
  { id: "rain_22", text: "Skýin eru greinilega með verkefni." },
  { id: "rain_23", text: "Þetta er víst gott fyrir gróðurinn." },
  { id: "cold_01", text: "Lopapeysan hafði rétt fyrir sér." },
  { id: "cold_03", text: "Kaffið kólnar af samúð." },
  { id: "cold_04", text: "Þetta er bara hressandi." },
  { id: "cold_05", text: "Það er víst enginn kuldi." },
  { id: "cold_06", text: "Bara spurning um að klæða sig." },
  { id: "cold_07", text: "Hitinn er með mjög hófleg markmið." },
  { id: "cold_08", text: "Þetta telst víst ferskt." },
  { id: "cold_09", text: "Hitamælirinn er ekkert sérstaklega metnaðarfullur." },
  { id: "cold_10", text: "Stuttbuxurnar fá frí." },
  { id: "cold_11", text: "Þetta er peysuveður." },
  { id: "cold_12", text: "Hitinn mætti ekki." },
  { id: "cold_13", text: "Það er allavega ekki of heitt." },
  { id: "cold_14", text: "Hitinn fór eitthvað annað." },
  { id: "cold_15", text: "Jæja. Ull." },
  { id: "cold_16", text: "Ferskt. Mjög ferskt." },
  { id: "cold_17", text: "Þetta er ein leið til að vakna." },
  { id: "cold_18", text: "Hlýtt er afstætt hugtak." },
  { id: "cold_19", text: "Hitamælirinn heldur aftur af sér." },
  { id: "cold_20", text: "Ekki alveg hitabylgja." },
  { id: "cold_21", text: "Hitinn lætur lítið fyrir sér fara." },
  { id: "cold_22", text: "Kuldinn mætti." },
  { id: "cold_23", text: "Það vantar nokkrar gráður." },
  { id: "cold_24", text: "Það er enginn kuldi, bara lélegur klæðnaður." },
  { id: "sun_wind_01", text: "Sólin mætir. Lognið ekki." },
  { id: "sun_wind_02", text: "Bjart yfir. Hárið á hlið." },
  { id: "sun_wind_03", text: "Sólin kom. Vindurinn líka." },
  { id: "sun_wind_04", text: "Bjart og blásið." },
  { id: "sun_wind_05", text: "Sólin gerir sitt. Vindurinn líka." },
  { id: "sun_wind_06", text: "Fallegt. Með mótvindi." },
  { id: "sun_wind_07", text: "Sólin lofar góðu. Vindurinn hefur aðrar hugmyndir." },
  { id: "sun_wind_08", text: "Bjart yfir. Rólegt, síður." },
  { id: "sun_wind_09", text: "Sólin er saklaus af þessu." },
  { id: "sun_wind_10", text: "Vindurinn lætur sólina ekki eiga sviðið." },
  { id: "sun_wind_11", text: "Sól með aukahljóðum." },
  { id: "sun_wind_12", text: "Bjart. En ekki beint kyrrt." },
  { id: "sun_wind_13", text: "Sólin mætti ekki ein." },
  { id: "sun_wind_14", text: "Fallegt úr fjarlægð." },
  { id: "sun_wind_15", text: "Sól og vindur. Klassískt samstarf." },
  { id: "sun_wind_16", text: "Veðrið gat ekki bara verið gott." },
  { id: "sun_wind_17", text: "Sólin reynir." },
  { id: "sun_wind_18", text: "Bjartviðri með fyrirvara." },
  { id: "sun_wind_19", text: "Sólskin. Með smá mótþróa." },
  { id: "sun_wind_20", text: "Vindurinn vill líka athygli." },
  { id: "sun_wind_21", text: "Sól að ofan. Vindur frá hlið." },
  { id: "sun_wind_22", text: "Næstum því fullkomið." },
];
